import './global-notification.less';
import closeIcon from '../../../images-svg-sprite/close_icon.svg';
import Attention from '../../../images-svg-sprite/attention_white.svg';
import { templateToNodeList, appendNodesTo } from '../../../utils/templateToNodeList';

export class GlobalNotification {
    static BLOCK_CLASS_NAME = 'apc-global-notification';

    /**
     * Create a Global Notification Component
     * @param {string} type
     */
    constructor(type) {
        this.type = type;
    }

    hide() {
        Array.from(document.querySelectorAll(`.${GlobalNotification.BLOCK_CLASS_NAME}`)).forEach(
            element => {
                element.parentElement.removeChild(element);
            }
        );
    }

    /**
     * Show a notification
     * @param {string} text
     * @param {HTMLElement} placement
     */
    show(text, placement, leftIcon = Attention) {
        this.hide();
        const stickyProductInfo = document.querySelector('.product-description-block__sticked');
        const width = leftIcon.width || 20;
        const template = `
            <div class="${GlobalNotification.BLOCK_CLASS_NAME} ${
            GlobalNotification.BLOCK_CLASS_NAME
        }_theme_${this.type}" ${stickyProductInfo ? 'style="top: 119px"' : ''}>
                <div class="${GlobalNotification.BLOCK_CLASS_NAME}__content">
                    <div class="${
                        GlobalNotification.BLOCK_CLASS_NAME
                    }__icon" style="width: ${width}px; min-width: ${width}px">
                        <svg viewBox="${
                            leftIcon.viewBox
                        }" style="width: ${width}px; min-width: ${width}px">
                            <use xlink:href="#${leftIcon.id}" />
                        </svg>
                    </div>
                    <p>${text}</p>
                    <div class="${GlobalNotification.BLOCK_CLASS_NAME}__close">
                        <div class="apc-global-notification__close-icon-wrapper">
                            <svg viewBox="${closeIcon.viewBox}">
                                <use xlink:href="#${closeIcon.id}" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`;

        const fragment = document.createDocumentFragment('div');
        const appendedFragment = appendNodesTo(templateToNodeList(template), fragment);

        if (placement) {
            placement.parentElement.insertBefore(appendedFragment, placement);
        } else {
            document.body.insertBefore(appendedFragment, document.body.childNodes[0]);
        }

        document
            .querySelector(`.${GlobalNotification.BLOCK_CLASS_NAME}__close`)
            .addEventListener('click', () => this.hide());
    }
}
